import { Link } from "react-router-dom";
import { LOGO_DIAMOND } from "@/lib/site";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#050505] px-5 py-24 md:px-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/termin" data-testid="privacy-back" className="mb-12 inline-flex items-center gap-3">
          <img src={LOGO_DIAMOND} alt="Onarf Marketing" className="h-7 w-7 object-contain" />
          <span className="font-display text-sm font-black uppercase tracking-[0.18em] text-white">Onarf</span>
        </Link>

        <span className="eyebrow">Pravno</span>
        <h1 className="mt-4 mb-10 font-display text-4xl font-extrabold uppercase tracking-tight text-white md:text-5xl">
          Politika privatnosti
        </h1>

        <div className="flex flex-col gap-8 text-sm leading-relaxed text-white/70">
          <p>
            Ova Politika privatnosti objašnjava kako Onarf Marketing prikuplja, koristi i štiti osobne
            podatke koje nam ostavljate putem obrasca na ovoj stranici, u skladu s Općom uredbom o
            zaštiti podataka (GDPR) i primjenjivim propisima Republike Hrvatske.
          </p>

          <Section title="1. Voditelj obrade">
            Onarf Marketing, [PLACEHOLDER — puni pravni naziv], [PLACEHOLDER — adresa], OIB:
            [PLACEHOLDER — OIB]. Kontakt: onarf.marketing@gmail.com.
          </Section>

          <Section title="2. Koje podatke prikupljamo">
            Ime i prezime, broj telefona, e-mail adresu, naziv ordinacije/poliklinike te sadržaj poruke
            koju nam pošaljete. Prikupljamo isključivo podatke koje sami unesete u obrazac.
          </Section>

          <Section title="3. Svrha i pravna osnova obrade">
            Podatke obrađujemo kako bismo vas kontaktirali, dogovorili konzultacije i pružili ponudu
            naših usluga. Pravna osnova je vaša privola koju dajete slanjem obrasca, odnosno poduzimanje
            radnji na vaš zahtjev prije sklapanja ugovora.
          </Section>

          <Section title="4. Dijeljenje podataka">
            Vaše podatke pohranjujemo u našem CRM sustavu (HubSpot). Podatke ne prodajemo niti dijelimo
            s trećim stranama u marketinške svrhe. Pružatelji usluga koje koristimo obrađuju podatke
            isključivo po našim uputama i u skladu s GDPR-om.
          </Section>

          <Section title="5. Razdoblje čuvanja">
            Podatke čuvamo onoliko dugo koliko je potrebno za ostvarenje navedene svrhe, a najduže do
            povlačenja vaše privole ili prestanka poslovnog odnosa.
          </Section>

          <Section title="6. Vaša prava">
            Imate pravo na pristup, ispravak, brisanje i ograničenje obrade svojih podataka, pravo na
            prigovor te pravo na povlačenje privole u bilo kojem trenutku. Zahtjev možete poslati na
            onarf.marketing@gmail.com. Također imate pravo podnijeti pritužbu Agenciji za zaštitu
            osobnih podataka (AZOP).
          </Section>

          <Section title="7. Kontakt">
            Za sva pitanja vezana uz zaštitu podataka obratite nam se na onarf.marketing@gmail.com.
          </Section>

          <p className="text-xs text-white/40">Zadnje ažuriranje: [PLACEHOLDER — datum]</p>
        </div>

        <Link
          to="/termin"
          data-testid="privacy-return-cta"
          className="mt-14 inline-flex items-center gap-2 bg-[#50C878] px-8 py-4 font-display text-xs font-extrabold uppercase tracking-widest text-black transition-colors hover:bg-[#3EB264]"
        >
          Natrag na stranicu
        </Link>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="flex flex-col gap-3">
      <h2 className="flex items-center gap-3 font-display text-base font-bold uppercase tracking-wide text-white">
        <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
        {title}
      </h2>
      <p>{children}</p>
    </div>
  );
}
